import '../styles/LandingEntryActions.css';
import React from 'react';

function LandingEntryActions() {
  return (
    <section className="lea-section" aria-labelledby="lea-band-heading">
      <span className="lea-register lea-register--tr" aria-hidden="true" />
      <span className="lea-register lea-register--bl" aria-hidden="true" />

      <div className="lea-inner">
        <h2 className="lea-eyebrow" id="lea-band-heading">
          <span className="lea-eyebrow-mark" aria-hidden="true" />
          Consignment tracking — start here
        </h2>

        <div className="lea-controls">
          <a className="lea-cta" href="/track-shipment">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <circle cx="11" cy="11" r="7" />
              <line x1="16.5" y1="16.5" x2="21" y2="21" />
            </svg>
            Track a shipment
          </a>

          <a className="lea-secondary" href="/login">
            <span className="lea-secondary-text">
              Returning participant sign in
            </span>
            <svg
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="13 6 19 12 13 18" />
            </svg>
          </a>
        </div>

        <p className="lea-ruled-note">
          <span>Fast Forward Deliver Services</span>
        </p>
      </div>
    </section>
  );
}

export default LandingEntryActions;